import { purify } from "../../../_src/components/purify";

export function searchBulletinsAgroclimatic() {
    var btnLoadMore = document.querySelector("[data-action=load-more]")

    function search(loadMore) {
        var form = document.querySelector('#filter-bulletinsAgroclimatic');
        var data = new FormData(form);

        if (btnLoadMore) {
            btnLoadMore.classList.add("loading")
        }

        if (!loadMore) {
            document.querySelector("#result-bulletinsAgroclimatic").innerHTML = "";
            document.querySelector(".loader-bulletins-agroclimatic").classList.remove("hidden")
        }

        document.querySelectorAll("#filter-bulletinsAgroclimatic fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        fetch(`/ifag/dados-e-analises/ajax/bulletins-agroclimatic.html/p${ btnLoadMore ? btnLoadMore.getAttribute("data-page") : 1}?&loadmore=${loadMore}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                btnLoadMore.parentElement.insertAdjacentHTML('beforebegin', response);

                if (document.querySelector("#result-not-found")) {
                    btnLoadMore.classList.add("hidden")
                    document.querySelector("#result-not-found").remove()
                } else {
                    btnLoadMore.classList.remove("hidden")
                }
            } else {
                document.querySelector("#result-bulletinsAgroclimatic").innerHTML = purify(response);

                searchBulletinsAgroclimatic();
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            if (!loadMore) {
                document.querySelector(".loader-bulletins-agroclimatic").classList.add("hidden")
            }

            if (btnLoadMore) {
                btnLoadMore.classList.remove("loading")

                if ( parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.total) ) {
                    btnLoadMore.classList.add('hidden');
                }
            }

            document.querySelectorAll("#filter-bulletinsAgroclimatic fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })
        });
    }

    if (btnLoadMore) {
        btnLoadMore.addEventListener("click", function() { search(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
    }

    document.querySelector("#filter-bulletinsAgroclimatic").addEventListener("change", function(event) { event.preventDefault(), setTimeout(() => { search(false) }, 100), btnLoadMore ? btnLoadMore.dataset.page = "1" : '' }, false);
}

if (document.querySelector("#filter-bulletinsAgroclimatic")) {
    searchBulletinsAgroclimatic();
}
